export class LazyValue {
    #thunk;
    #evaluated
    #result;
    constructor(thunk) {
        this.#thunk = thunk;
        this.#evaluated = false;
    }
    async evaluate() {
        if (!this.#evaluated) {
            this.#result = await this.#thunk();
        }
        return this.#result;
    }
}

/**
 * Encapsualte a thunk into a lazy value where thunk evaluation is delayed until required.
 * @param {Function} thunk a parameterless function which, when invoked will resolve to a value
 * @returns a lazy resolution value which will invoke the thunk when a value is required
 */
export const lazyValue = (thunk) => new LazyValue(thunk);

export const materializeValue = async value => {
    if (value && value instanceof LazyValue) {
        return await value.evaluate();
    }
    return value;
}

/**
 * Test if a given value is a lazy value
 * @param {*} v value to test
 * @returns true if the value is a lazy value
 */
export function isLazyValue(v) {
    return v && typeof v === "object" && v instanceof LazyValue;
}